import React from 'react';
import Parent from '../parent';
import { withTranslation } from 'react-i18next';
import { constants } from "../constants/constants";
import './allPaid.css';


export class AllPaid extends Parent {

    render(){

        const {t} = this.props
        this.setBodyClasses(constants.backgroundOptions.allPaymentsPaid);

        return (
            <div className="container">
                <div className="paid_all">
                    <div className="already_payment">
                        <h4>{t('payments.everything_is_paid')}
                            <span role="img" aria-label="smiley" >😉</span>
                        </h4>

                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(AllPaid)
